/**
 * @enclaved/encli
 * CLI utilities for working with enclaved application server for TEEs
 */

// Export commands for programmatic usage
export * from './commands/test';
export * from './commands/sign_build';

// Add more exports as needed